import React from "react";

const PrimaryButton = ({
  type,
  full,
  text,
  onClick,
  rounded,
  disabled,
  loading,
  bgColor,
}) => {
  return (
    <button
      type={type}
      className={`border-[1px]  text-white px-5 py-[6px] cursor-pointer disabled:bg-gray-300 disabled:border-0  ${
        rounded ? "rounded-full" : "rounded"
      }  ${full && "w-full"} ${
        loading
          ? "bg-gray-300 text-slate-600"
          : bgColor
          ? bgColor
          : `bg-black border-black`
      }`}
      disabled={disabled}
      onClick={onClick}>
      {text}
    </button>
  );
};

export default PrimaryButton;
